import type { ModelActionsType } from "../actions/ModelActions";
import { SET_MODEL } from "../actions/ModelActions";
import type { ModelType } from "../../../../../common-deprecated/types/CommonTypes";

export const initialState: ModelType = {
    id: "",
    name: "",
    description: "",
    internalCode: "",
    grades: [],
    defaultCarId: "",
    filterItems: [],
    configVersion: "",
    labels: [],
};

const modelReducer = (state: ModelType = initialState, action: ModelActionsType): ModelType => {
    switch (action.type) {
        case SET_MODEL:
            return action.model;

        default:
            return state;
    }
};

export default modelReducer;
